import { isSaleCustomer, inStorePicking, exchangeManagementDetail, confirmationDispatchesMobile } from './card-list-config';

export const SCHEMAS = {
  inStorePicking: inStorePicking,
  exchangeManagementDetail: exchangeManagementDetail,
  isSaleCustomer : isSaleCustomer,
  confirmationDispatches : confirmationDispatchesMobile,
};

